module.exports = __webpack_public_path__ + "img/03_bohle.66ec70d7.jpeg";